export default "__VITE_ASSET__SLlMjZFn__"